module.exports = __webpack_public_path__ + "img/venues_private_table.21780dee.jpg";